import React, { Component } from 'react';

class Home extends Component {
  render() {
    return (
      <div className="homedetails">
        <div className="homecontent">
          <div className="homecontent__text">
            <h1 className="hometitle">WELCOME TO APLī</h1>
            <h2 className="homesubtitle">
              Empowering schools to manage applications smarter
            </h2>
            <a className="homebutton" href="#homedetails">
              LEARN MORE
            </a>
          </div>
        </div>
        <div className="content homedetails" id="homedetails">
          <h3>We can help you</h3>
          <div className="row detailcells">
            <div className="col-sm-4 col-xs-12">
              <img src={require('../img/dashboard-icon.svg')} alt="" />
              <p>
                Receive, manage and process applications from all sources and
                agencies in one location
              </p>
            </div>
            <div className="col-sm-4 col-xs-12">
              <img src={require('../img/avatar.svg')} alt="" />
              <p>
                Evaluate, compare and rank applicants easily and efficiently
              </p>
            </div>
            <div className="col-sm-4 col-xs-12 ">
              <img src={require('../img/group-3.svg')} alt="" />
              <p>
                Collaborate with your entire team by sharing information with
                ease
              </p>
            </div>
          </div>
          <div className="row detailcells">
            <div className="col-sm-4 col-xs-12">
              <img src={require('../img/search.svg')} alt="" />
              <p>
                Refined searches to help you identify the best candidates
                quickly
              </p>
            </div>
            <div className="col-sm-4 col-xs-12">
              <img src={require('../img/settings-4.svg')} alt="" />
              <p>Customize your vacancies to attract the right applicants</p>
            </div>
            <div className="col-sm-4 col-xs-12 ">
              <img src={require('../img/lock.svg')} alt="" />
              <p>
                Comprehensive candidate files to include confidential references
              </p>
            </div>
          </div>
          <div className="row detailcells">
            <div className="col-sm-4 col-xs-12">
              <img src={require('../img/chat-11.svg')} alt="" />
              <p>
                Communicate seamlessly with applicants through customizable
                email templates
              </p>
            </div>
            <div className="col-sm-4 col-xs-12">
              <img src={require('../img/cloud-2.svg')} alt="" />
              <p>
                Build your own private database of applicants for future
                reference
              </p>
            </div>
            <div className="col-sm-4 col-xs-12 ">
              <img src={require('../img/amplify.svg')} alt="" />
              <p>
                Promote and market your school by directing a wide range of
                educators to your website
              </p>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default Home;



// WEBPACK FOOTER //
// ./src/containers/home.js